import { atom } from 'recoil'
import { View } from 'common/types/odino/view'
import { EntityViews } from '../hooks/use-views/useViews'

export const entityViewsState = atom<{[key: string]: EntityViews}>({
  key: 'entity-views-state',
  default: {}
})
